import React from 'react';
import SEO from '../components/SEO';

const ManufacturingProcess = () => {
  const steps = [
    
    {
      title: 'Material Selection',
      description: 'We use premium materials, including high-grade leather and durable fabrics, ensuring quality and comfort.',
      image: '/Boxing/Categories/6.webp',
    },
    {
      title: 'Cutting & Stitching',
      description: 'Our skilled craftsmen meticulously cut and stitch each glove, ensuring precision and durability.',
      image: '/Boxing/Categories/7.webp',
    },
    {
      title: 'Padding & Assembly',
      description: 'State-of-the-art machinery is used to insert padding and assemble the gloves for maximum protection.',
      image: '/Boxing/Categories/12.webp',
    },
    {
      title: 'Quality Inspection',
      description: 'Every product undergoes rigorous quality checks to meet international standards.',
      image: '/Boxing/Categories/14.webp',
    },
    {
      title: 'Packaging & Shipping',
      description: 'Finished products are carefully packed and shipped globally to our trusted customers.',
      image: '/Boxing/Categories/15.webp',
    },
  ];

  return (
    <section className="py-12 bg-gray-100 mt-[100px] ">
        <SEO
          title="Our Manufacturing Process | IES Gear"
          description="Explore the premium manufacturing process behind IES Gear boxing gloves, fight gear, and custom sportswear from concept to export."
          keywords="boxing gloves manufacturing process, custom sportswear production, fight gear manufacturing"
          url="https://iesgear.com/manufacturing-process"
        />
      <div className="max-w-screen-xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-center text-black mb-8">
          <span className='text-brand-color'>Our</span> Manufacturing Process
        </h2>
        <div className="space-y-12">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`flex flex-col md:flex-row items-center ${
                index % 2 !== 0 ? 'md:flex-row-reverse' : ''
              }`}
            >
              {/* Image Section */}
              <div className="w-full md:w-1/2 p-4">
                <img
                  src={step.image}
                  alt={step.title}
                  className="rounded-lg shadow-lg w-full h-auto"
                />
              </div>
              {/* Text Section */}
              <div className="w-full md:w-1/2 p-4">
                <h3 className="text-2xl font-semibold text-black mb-4">
                  {step.title}
                </h3>
                <p className="text-lg text-black">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ManufacturingProcess;
